import { render, staticRenderFns } from "./BpCheckboxesDropdown.vue?vue&type=template&id=bde27f64&scoped=true&"
import script from "./BpCheckboxesDropdown.vue?vue&type=script&lang=js&"
export * from "./BpCheckboxesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BpCheckboxesDropdown.vue?vue&type=style&index=0&id=bde27f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde27f64",
  null
  
)

export default component.exports